/* NSH 게이트·언어분기 — 2026-08-27 템플릿 인라인에서 자산으로 분리. 내용 불변.

   1) 진입 언어 분기
      예전에는 템플릿이 html lang 을 ko 로 고정 출력해서, /en · /ja 에서
      여기가 불일치를 보고 ?lang= 을 붙여 페이지를 다시 받았다.
      이젠 서버가 lang 을 제대로 내리므로 이 분기는 저절로 안 돌아간다.
      로직은 그대로 둔다 — 혹시 모를 경로를 위한 안전망이다.

   2) 이중언어 게이트 동의문 (html lang 기준 KO/EN) */
(function(){
  try{
    var pathLoc = /^\/ko(\/|$)/.test(location.pathname) ? 'ko' : (/^\/ja(\/|$)/.test(location.pathname) ? 'ja' : 'en');
    if(!/[?&]lang=/.test(location.search)){
      if(localStorage.getItem('nshLoc') !== pathLoc){ try{ localStorage.setItem('nshLoc', pathLoc); }catch(e){} }
      var force=function(){
        var l=(document.documentElement.lang||'').toLowerCase();
        var cur = l.slice(0,2)==='ko' ? 'ko' : (l.slice(0,2)==='en' ? 'en' : '');
        if(cur && cur!==pathLoc){
          var sep = location.search ? '&' : '?';
          location.replace(location.pathname + location.search + sep + 'lang=' + pathLoc + location.hash);
        }
      };
      if(document.readyState!=='loading') setTimeout(force,120);
      else document.addEventListener('DOMContentLoaded', function(){ setTimeout(force,120); });
    }
  }catch(e){}
})();
(function(){
  function patch(){
    var res=document.querySelector('#result.gated'); if(!res) return;
    var en=(document.documentElement.lang||'').toLowerCase().indexOf('en')===0;
    var tag=en?'en':'ko';
    /* gateLead 카피는 v5.1 의 patchGate 가 KO/EN 모두 담당 — 이중 작성 경합·관찰자 루프 제거 */
    var c=res.querySelector('p.consent');
    if(c && c.getAttribute('data-nsh')!==tag){
      c.setAttribute('data-nsh',tag);
      var a=c.querySelector('a'); var href=a?a.getAttribute('href'):'/policies/privacy-policy';
      c.innerHTML = en
        ? 'By leaving your email, you agree to our <a href="'+href+'">Privacy Policy</a>, and we\'ll keep sending stories for your skin. Unsubscribe anytime.'
        : '<a href="'+href+'">개인정보 처리방침</a>에 동의하고 이메일을 남겨주시면, 내 고민에 도움이 될 이야기를 더 보내드릴게요. 언제든 취소할 수 있어요.';
    }
  }
  function init(){ patch(); try{ new MutationObserver(patch).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['class','lang']}); }catch(e){} }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded',init);
})();
